import { RouteRecordRaw } from 'vue-router';

export default (): Array<RouteRecordRaw> => {
    return [
        {
            path: '/home',
            name: 'home',
            component: () => import("./views/home.vue"),
            meta: {
                hasBar: true,
                closeAppModal: true
            }
        },
        {
            path: '/home/:identifier',
            name: 'home_identifier',
            component: () => import("./views/home.vue"),
            meta: {
                hasBar: false,
            }
        },
        {
            path: '/datiPersonali',
            name: 'datiPersonali',
            component: () => import("./views/datiPersonali.vue"),
        },
    ];
};